module.exports = __webpack_public_path__ + "img/qilin-f-stage4.e5132af2.png";